import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  userService,
  vmDataService,
} from 'app/services';
import performControlsReviewDialog from '../dialog.performControlsReviewDialog';
import completeControlReviewWithNoControlsDialog from '../dialog.completeControlReviewWithNoControlsDialog';
import controller from './select-risk-controls-for-review-dialog.controller';
import template from './select-risk-controls-for-review-dialog.html';


class dialogService {
  getOptions($event, { riskControlReviewTaskId, vendor, product }) {
    return {
      controller,
      controllerAs: 'selectRiskControlsForReviewDialogVM',
      locals: {
        riskControlReviewTaskId,
        vendor,
        product
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.selectRiskControlsForReviewDialog', [
  constants,
  loaderService,
  ssDialogService,
  userService,
  vmDataService,
  performControlsReviewDialog,
  completeControlReviewWithNoControlsDialog,
])
  .service('selectRiskControlsForReviewDialog', dialogService)
  .name;
